import React from 'react'
import { Button, Grid, IconButton, Typography } from '@material-ui/core'
import { AddTwoTone, SelectAllRounded } from '@material-ui/icons'
import { useEmptyStyles } from './empty.styles'
import { Link } from 'react-router-dom'

export const EmptyLists = () => {
  const classes = useEmptyStyles()

  return (
    <Grid item container>
      <Grid
        item
        container
        xs={12}
        md={12}
        direction="column"
        justifyContent="center"
        alignItems="center"
        style={{ height: '30vh' }}
      >
        <IconButton size="small" className={classes.icon}>
          <SelectAllRounded />
        </IconButton>
        <Typography className={classes.title}>
          У вас нету заявок в поддержку
        </Typography>
        <Link to="/CreationPanel" style={{ textDecoration: 'none' }}>
          <Button variant="contained" color="primary">
            <AddTwoTone />
            Создать заявку
          </Button>
        </Link>
      </Grid>
    </Grid>
  )
}
